import { z } from 'zod';
import { $getFiltersRequestType } from '@shared/types';

const $Skill = z.object({
  id: z.number(),
  name: z.string(),
});

export type GetSkillsRequest = z.infer<typeof $GetSkillsRequest>;
export const $GetSkillsRequest = $getFiltersRequestType(z.object({}));

export const $GetSkillsResponse = z.array($Skill);

export type GetSkillsResponse = z.infer<typeof $GetSkillsResponse>;
